module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-d"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_vm._v("To my mentor and friend Robert W. Sparks, whose store of courtroom stories is surpassed only by the number of juries he has persuaded to go along with him; to my friends in the Johnson & Johnson Law Department who bear not even a smidgen of resemblance to the characters in this book; to Francisca, who knows why; and mostly, of course, to Sheila, Olivia, and Annabel, the sum of my good fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("A good lawyer would tell me I need to say that any similarity between characters in this novel and actual people living or dead is entirely coincidental. All right.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ea2096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Dedication.vue
// module id = 69
// module chunks = 0